import React from "react";
import InlineMessage, { InlineMessageVariant } from "@ingka/inline-message";
import informationCircle from "@ingka/ssr-icon/paths/information-circle";
import checkmarkCircle from "@ingka/ssr-icon/paths/checkmark-circle";
import warningTriangle from "@ingka/ssr-icon/paths/warning-triangle";
import crossCircle from "@ingka/ssr-icon/paths/cross-circle";

import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/hyperlink/dist/style.css";
import "@ingka/inline-message/dist/style.css";
import "@ingka/text/dist/style.css";
import "@ingka/focus/dist/style.css";

type FixaInlineMessageProps = {
  type?: "confirmation" | "information" | "warning" | "error";
  title?: string;
  role?: string;
  ariaLive?: "off" | "polite" | "assertive";
  body?: React.ReactNode;
};

const MESSAGE_CONFIG: Record<
  NonNullable<FixaInlineMessageProps["type"]>,
  {
    variant: InlineMessageVariant;
    icon: (prefix?: string) => React.SVGProps<SVGElement>[];
  }
> = {
  confirmation: { variant: "positive", icon: checkmarkCircle },
  information: { variant: "informative", icon: informationCircle },
  warning: { variant: "cautionary", icon: warningTriangle },
  error: { variant: "negative", icon: crossCircle },
};

export const FixaInlineMessage = ({ type = "information", title, role, ariaLive, body }: FixaInlineMessageProps) => {
  const { variant, icon } = MESSAGE_CONFIG[type];

  return <InlineMessage variant={variant} ssrIcon={icon} title={title} role={role} aria-live={ariaLive} body={body} />;
};
